export default {
  aluminum: { field: 'aluminum', title: 'Al', fieldType: 'numeric' },
  aluminumSeverityId: { field: 'aluminumSeverityID', fieldType: 'numeric' },
  antifreeze: { field: 'antifreeze', fieldType: 'numeric' },
  antifreezeSeverityId: { field: 'antifreezeSeverityID', fieldType: 'numeric' },
  barium: { field: 'barium', title: 'Ba', fieldType: 'numeric' },
  bariumSeverityId: { field: 'bariumSeverityId', fieldType: 'numeric' },
  billingDescription: { field: 'billingDescription' },
  billingThirdParty: { field: 'billingThirdParty' },
  boron: { field: 'boron', title: 'B', fieldType: 'numeric' },
  boronSeverityId: { field: 'boronSeverityID', fieldType: 'numeric' },
  cadmium: { field: 'cadmium', title: 'Cd', fieldType: 'numeric' },
  cadmiumSeverityId: { field: 'cadmiumSeverityId', fieldType: 'numeric' },
  calcium: { field: 'calcium', title: 'Ca', fieldType: 'numeric' },
  calciumSeverityId: { field: 'calciumSeverityID', fieldType: 'numeric' },
  chromium: { field: 'chromium', title: 'Cr', fieldType: 'numeric' },
  chromiumSeverityId: { field: 'chromiumSeverityID', fieldType: 'numeric' },
  chlorine: { field: 'chlorine', title: 'Cl', fieldType: 'numeric' },
  chlorineSeverityId: { field: 'chlorineSeverityID', fieldType: 'numeric' },
  commentId: { field: 'commentID', fieldType: 'numeric' },
  comments: { field: 'comments' },
  copper: { field: 'copper', title: 'Cu', fieldType: 'numeric' },
  copperSeverityId: { field: 'copperSeverityID', fieldType: 'numeric' },
  createdOn: { field: 'createdOn', fieldType: 'datetime' },
  customerCode: { field: 'customerCode' },
  customerComments: { field: 'customerComments' },
  customerId: { field: 'customerID', required: true, fieldType: 'numeric' },
  customerName: { field: 'customerName' },
  customerThirdParty: { field: 'customerThirdParty' },
  dateReceived: { field: 'dateReceived', fieldType: 'datetime' },
  dateSampled: { field: 'dateSampled', fieldType: 'datetime' },
  fluidActionCode: { field: 'fluidActionCode' },
  fluidActionId: { field: 'fluidActionID', fieldType: 'numeric' },
  fluidActionName: { field: 'fluidActionName' },
  fluidCode: { field: 'fluidCode' },
  fluidId: { field: 'fluidID', fieldType: 'numeric' },
  fluidName: { field: 'fluidName' },
  fuelDilution: { field: 'fuelDilution', fieldType: 'numeric' },
  fuelDilutionSeverityId: { field: 'fuelDilutionSeverityID', fieldType: 'numeric' },
  mpc: { field: 'mpc', title: 'MPC', fieldType: 'numeric' },
  mpcSeverityId: { field: 'mpcSeverityId', fieldType: 'numeric' },
  isoClassCode: { field: 'isoClassCode', title: 'ISO Class Code' },
  isoClassCodeSeverityId: { field: 'isoClassCodeSeverityId', fieldType: 'numeric' },
  iron: { field: 'iron', title: 'Fe', fieldType: 'numeric' },
  ironSeverityId: { field: 'ironSeverityID', fieldType: 'numeric' },
  isBillable: { field: 'isBillable', fieldType: 'boolean' },
  isBillingBasicSample: { field: 'isBillingBasicSample', fieldType: 'boolean' },
  isBillingCL: { field: 'isBillingCL', fieldType: 'boolean' },
  isBillingGLY: { field: 'isBillingGLY', fieldType: 'boolean' },
  isBillingKF: { field: 'isBillingKF', fieldType: 'boolean' },
  isBillingNC: { field: 'isBillingNC', fieldType: 'boolean' },
  isBillingNOB: { field: 'isBillingNOB', fieldType: 'boolean' },
  isBillingPC: { field: 'isBillingPC', fieldType: 'boolean' },
  isBillingRUSH: { field: 'isBillingRUSH', fieldType: 'boolean' },
  isBillingSUL: { field: 'isBillingSUL', fieldType: 'boolean' },
  isBillingTAN: { field: 'isBillingTAN', fieldType: 'boolean' },
  isBillingTBN: { field: 'isBillingTBN', fieldType: 'boolean' },
  isBillingBN: { field: 'isBillingBN', fieldType: 'boolean' },
  jobNumber: { field: 'jobNumber' },
  lead: { field: 'lead', title: 'Pb', fieldType: 'numeric' },
  leadSeverityId: { field: 'leadSeverityID', fieldType: 'numeric' },
  magnesium: { field: 'magnesium', title: 'Mg', fieldType: 'numeric' },
  magnesiumSeverityId: { field: 'magnesiumSeverityID', fieldType: 'numeric' },
  manganese: { field: 'manganese', title: 'Mn', fieldType: 'numeric' },
  manganeseSeverityId: { field: 'manganeseSeverityId', fieldType: 'numeric' },
  makeUpOil: { field: 'makeUpOil', fieldType: 'numeric' },
  makeUpOilUnitOfMeasureId: { field: 'makeUpOilUnitOfMeasureID', fieldType: 'numeric' },
  makeUpOilUnitOfMeasureName: { field: 'makeUpOilUnitOfMeasureName' },
  manufacturerModelName: { field: 'manufacturerModelName', title: 'Manufacturer Model' },
  meterReading: { field: 'meterReading' },
  meterReadingUnitOfMeasureId: { field: 'meterReadingUnitOfMeasureID', fieldType: 'numeric' },
  meterReadingUnitOfMeasureName: { field: 'meterReadingUnitOfMeasureName' },
  milesOrHoursOnSample: { field: 'milesOrHoursOnSample' },
  milesOrHoursOnSampleUnitOfMeasureId: {
    field: 'milesOrHoursOnSampleUnitOfMeasureID',
    fieldType: 'numeric'
  },
  milesOrHoursOnSampleUnitOfMeasureName: { field: 'milesOrHoursOnSampleUnitOfMeasureName' },
  modifiedOn: { field: 'modifiedOn', fieldType: 'datetime' },
  molybdenum: { field: 'molybdenum', title: 'Mo', fieldType: 'numeric' },
  molybdenumSeverityId: { field: 'molybdenumSeverityID', fieldType: 'numeric' },
  nickel: { field: 'nickel', title: 'Ni', fieldType: 'numeric' },
  nickelSeverityId: { field: 'nickelSeverityID', fieldType: 'numeric' },
  oilSampleId: { field: 'oilSampleID', fieldType: 'numeric' },
  nitration: { field: 'nitration', fieldType: 'numeric', title: 'Nitr (E2412)' },
  nitrationSeverityId: { field: 'nitrationSeverityID', fieldType: 'numeric', title: 'Nitr (E2412) Severity ID' },
  oxidation: { field: 'oxidation', fieldType: 'numeric', title: 'Oxid (E2412)' },
  oxidationSeverityId: { field: 'oxidationSeverityID', fieldType: 'numeric', title: 'Oxid (E2412) Severity ID' },
  sulfation: { field: 'sulfation', fieldType: 'numeric', title: 'Sulf (E2412)' },
  sulfationSeverityId: { field: 'sulfationSeverityID', fieldType: 'numeric', title: 'Sulf (E2412) Severity ID' },
  newOxidation: { field: 'newOxidation', fieldType: 'numeric', title: 'Oxidation (D7414)' },
  newOxidationSeverityId: { field: 'newOxidationSeverityID', fieldType: 'numeric', title: 'Oxidation (D7414) Severity ID' },
  newNitration: { field: 'newNitration', fieldType: 'numeric', title: 'Nitration (D7624)' },
  newNitrationSeverityId: { field: 'newNitrationSeverityID', fieldType: 'numeric', title: 'Nitration (D7624) Severity ID' },
  newSulfation: { field: 'newSulfation', fieldType: 'numeric', title: 'Sulfation (D7415)' },
  newSulfationSeverityId: { field: 'newSulfationSeverityID', fieldType: 'numeric', title: 'Sulfation (D7415) Severity ID' },
  particleCount10: { field: 'particleCount10', fieldType: 'numeric' },
  particleCount100: { field: 'particleCount100', fieldType: 'numeric' },
  particleCount100SeverityId: { field: 'particleCount100SeverityID', fieldType: 'numeric' },
  particleCount10SeverityId: { field: 'particleCount10SeverityID', fieldType: 'numeric' },
  particleCount14: { field: 'particleCount14', fieldType: 'numeric' },
  particleCount14SeverityId: { field: 'particleCount14SeverityID', fieldType: 'numeric' },
  particleCount25: { field: 'particleCount25', fieldType: 'numeric' },
  particleCount25To50SeverityId: { field: 'particleCount25To50SeverityID', fieldType: 'numeric' },
  particleCount4: { field: 'particleCount4', fieldType: 'numeric' },
  particleCount4SeverityId: { field: 'particleCount4SeverityID', fieldType: 'numeric' },
  particleCount50: { field: 'particleCount50', fieldType: 'numeric' },
  particleCount50SeverityId: { field: 'particleCount50SeverityID', fieldType: 'numeric' },
  particleCount6: { field: 'particleCount6', fieldType: 'numeric' },
  particleCount6SeverityId: { field: 'particleCount6SeverityID', fieldType: 'numeric' },
  phosphorous: { field: 'phosphorous', title: 'P', fieldType: 'numeric' },
  phosphorousSeverityId: { field: 'phosphorousSeverityID', fieldType: 'numeric' },
  potassium: { field: 'potassium', title: 'K', fieldType: 'numeric' },
  potassiumSeverityId: { field: 'potassiumSeverityID', fieldType: 'numeric' },
  sampleNumber: { field: 'sampleNumber', required: true, fieldType: 'numeric' },
  sampleSeverityCode: { field: 'sampleSeverityCode' },
  sampleSeverityId: { field: 'sampleSeverityID', fieldType: 'numeric' },
  sampleSeverityName: { field: 'sampleSeverityName' },
  silicon: { field: 'silicon', title: 'Si', fieldType: 'numeric' },
  siliconSeverityId: { field: 'siliconSeverityID', fieldType: 'numeric' },
  silver: { field: 'silver', title: 'Ag', fieldType: 'numeric' },
  silverSeverityId: { field: 'silverSeverityID', fieldType: 'numeric' },
  sodium: { field: 'sodium', title: 'Na', fieldType: 'numeric' },
  sodiumSeverityId: { field: 'sodiumSeverityID', fieldType: 'numeric' },
  sootIndex: { field: 'sootIndex', fieldType: 'numeric' },
  sootIndexSeverityId: { field: 'sootIndexSeverityID', fieldType: 'numeric' },
  sulphur: { field: 'sulphur', title: 'S', fieldType: 'numeric' },
  sulphurSeverityId: { field: 'sulphurSeverityID', fieldType: 'numeric' },
  tan: { field: 'tan', title: 'AN (D664)', fieldType: 'numeric' },
  tanSeverityId: { field: 'tanSeverityID', title: 'AN (D664) Severity ID', fieldType: 'numeric' },
  tbn: { field: 'tbn', title: 'BN (D4739)', fieldType: 'numeric' },
  tbnSeverityId: { field: 'tbnSeverityID', title: 'BN (D4739) Severity ID', fieldType: 'numeric' },
  bn: { field: 'bn', title: 'BN (D2896)', fieldType: 'numeric' },
  bnSeverityId: { field: 'bnSeverityID', title: 'BN (D2896) Severity ID', fieldType: 'numeric' },
  tin: { field: 'tin', title: 'Sn', fieldType: 'numeric' },
  tinSeverityId: { field: 'tinSeverityID', fieldType: 'numeric' },
  titanium: { field: 'titanium', title: 'Ti', fieldType: 'numeric' },
  titaniumSeverityId: { field: 'titaniumSeverityId', fieldType: 'numeric' },
  unitId: { field: 'unitID', required: true, fieldType: 'numeric' },
  unitName: { field: 'unitName' },
  unitTypeName: { field: 'unitTypeName', title: 'Unit Type' },
  vanadium: { field: 'vanadium', title: 'V', fieldType: 'numeric' },
  vanadiumSeverityId: { field: 'vanadiumSeverityId', fieldType: 'numeric' },
  viscosity100c: { field: 'viscosity100c', fieldType: 'numeric' },
  viscosity100cSeverityId: { field: 'viscosity100CSeverityID', fieldType: 'numeric' },
  viscosity40c: { field: 'viscosity40c', fieldType: 'numeric' },
  viscosity40cSeverityId: { field: 'viscosity40CSeverityID', fieldType: 'numeric' },
  waterPercent: { field: 'waterPercent', title: 'Water (%)', fieldType: 'numeric' },
  waterPpm: { field: 'waterPpm', title: 'Water (ppm)', fieldType: 'numeric' },
  water: { field: 'water', fieldType: 'numeric' },
  waterDisplay: { field: 'waterDisplay' },
  waterSeverityId: { field: 'waterSeverityID', fieldType: 'numeric' },
  legacyWaterSeverityId: { field: 'legacyWaterSeverityID', fieldType: 'numeric' },
  waterSign: { field: 'waterSign' },
  waterUnitOfMeasureId: { field: 'waterUnitOfMeasureID', fieldType: 'numeric' },
  waterUnitOfMeasureName: { field: 'waterUnitOfMeasureName' },
  zinc: { field: 'zinc', title: 'Zn', fieldType: 'numeric' },
  zincSeverityId: { field: 'zincSeverityID', fieldType: 'numeric' }
};
